const sidebar = {
    open: document.getElementById('openSidebarDesk') as HTMLElement,
    popup: document.getElementById('sidebarWrap') as HTMLElement,
    grid: document.getElementById('productGrid') as HTMLElement,

    init() {
        if (window.innerWidth > 1200 && this.open) {
            this.copySidebar();
            this.setTriger();
        }

    },
    copySidebar(){
        const parent = this.grid.parentElement as HTMLElement;
        parent.prepend(this.popup)  
    },
    setTriger() {
        this.popup.classList.add('activeClass');
        this.grid.classList.add('activeClass');
        const text = this.open.firstElementChild as HTMLElement;
        text.innerText = 'hide filters';
        this.open.addEventListener('click', () => {         
            this.popup.classList.toggle('activeClass');
            this.grid.classList.toggle('activeClass');
            if (this.popup.classList.contains('activeClass')) {
                text.innerText = 'hide filters';
            } else {
                text.innerText = 'show filters';
            }
        })
    },


}

export default sidebar;